import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  createCustomSurveyTemplateVersion,
  CreateCustomSurveyTemplateRequest,
  CustomSurveyTemplate,
} from '../../api/customSurveyTemplates';
import { customSurveyTemplateKeys } from '../queries/queryKeys';

export const useCreateCustomSurveyTemplateVersionMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<
    CustomSurveyTemplate,
    Error,
    { id: number; data: CreateCustomSurveyTemplateRequest }
  >({
    mutationFn: ({ id, data }) => createCustomSurveyTemplateVersion(id, data),
    onSuccess: () => {
      // Invalidate both the template list and individual template queries
      queryClient.invalidateQueries({ queryKey: customSurveyTemplateKeys.all });
    },
  });
};
